<template>
  <div class="action-card wide-card" v-if="show">
    <b-button @click="show = false" type="button" class="close customClose" aria-label="Close" >
      <span aria-hidden="true">&times;</span>
    </b-button>
    <h2>Field options</h2>
    <b-input v-model="variable" placeholder="variable"/>
    <b-checkbox v-model="allowMultiline">Allow multi-line</b-checkbox>
    <b-checkbox v-model="forceCaps">Force Caps</b-checkbox>
    <b-checkbox v-model="fieldLocked">Field Locked</b-checkbox>
    <b-checkbox v-model="fieldDeletable">Field Deletable</b-checkbox>
    <div v-if="blockId">
      Block:
      <!-- debugging tool, turn on debugTools to see it -->
      <span
        style="text-align: left; font-size: small; border: 3px dashed blue; padding: 3px;"
        v-if="flags.debugTools"
        >
        Id: {{blockId}}
      </span>
      <b-form-radio-group v-model="blockVerticalAlign" size="sm" class="align-choices" button-variant="clear" buttons>
        <b-form-radio value="top">top</b-form-radio>
        <b-form-radio value="middle">middle</b-form-radio>
        <b-form-radio value="bottom">bottom</b-form-radio>
      </b-form-radio-group>
      <b-button variant="clear" size="sm" @click="emit('deleteBlock', blockId)"><i class="fas fa-times"/> Delete</b-button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  props: ['bus', 'canvasState'],
  data() {
    return {show: false}
  },
  computed: {
    ...mapGetters(['flags']),
    allowMultiline: {
      get() { return this.canvasState.allowMultiline; },
      set(val) { this.emit('setAllowMultiline', val); }
    },
    forceCaps: {
      get() { return this.canvasState.textTransform === 'uppercase'; },
      set(val) { this.emit('setTextTransform', val ? 'uppercase' : null); }
    },
    fieldLocked: {
      get() { return this.canvasState.fieldLocked; },
      set(val) { this.emit('setFieldLock', val); }
    },
    fieldDeletable: {
      get() { return this.canvasState.fieldDeletable; },
      set(val) { this.emit('setFieldDeletable', val); }
    },
    variable: {
      get() { return this.canvasState.variable; },
      set(val) { this.emit('setVariable', val); }
    },
    blockId () {
      return this.canvasState.blockId;
    },
    blockVerticalAlign: {
      get() { return ((this.canvasState.blocks||{})[this.canvasState.blockId]||{}).verticalAlign; },
      set(val) { this.emit('setBlockVerticalAlign', val); }
    }
  },
  methods: {
    emit(event, value) {
      console.log('emit', event, value);
      this.bus.$emit(event, value);
    }
  },

  events:{
    toggleFieldOptions() {
      this.show = !this.show;
    }
  },

  watch: {
    canvasState: {
      handler(val) {
        console.log('canvasState changed', val, val.fieldLocked);
      },
      deep: true,
    },
    show(shown) {
      this.bus.$emit('fieldOptionsVisibilityChange', {shown});
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  margin: 0;
}
.wide-card {
  width: 100%;
  max-width: 100%;
}

.customClose{
  height:0px;
  font-size:30px
}
</style>

<style lang="scss">
// unscoped, to affect the button group
.align-choices {
 .btn-clear {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 8px 15px;
    height: auto;
    &.active {
      background: white;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/pages/editor/FieldOptionsArea.vue